import Location from 'react-app-location';

export const AcceptedRequestsLocation = new Location('/requests/accepted');
